import { flexRender } from "@tanstack/react-table"
import { IBaseCell } from "./interface";

export const BaseCell = ({ cell }: IBaseCell) => {

  return flexRender(cell?.column?.columnDef?.cell, cell?.getContext()!);
}